<template>
  <div v-if="initialized" class="preview">
    <v-btn v-if="fullscreen" class="close-preview" @click="closePreview" icon>
      <v-icon color="primary">mdi-close</v-icon>
    </v-btn>

    <v-row v-if="isPreviewEnabled && !isCustomHtmlTab && products.length > 1 && !isSelfServe" justify="center" align="center">
      <!-- <v-col class="shrink result-select">
        <v-select hide-details v-model="previewProduct" :items="products" item-text="name" item-value="key" solo dense>

        </v-select>
      </v-col> -->

      <v-menu
        bottom
        origin="center center"
        transition="scale-transition"
      >
        <template v-slot:activator="{ on, attrs }">
          <div
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
            class="pt-2 d-flex align-center"
          >
            <span class="label">{{$t('preview_product_label')}}</span><span class="product-name pl-3 font-weight-bold">{{previewProduct.name}}<v-icon color="#0789b2">mdi-menu-down</v-icon></span>
          </div>
        </template>

        <v-list>
          <v-list-item
            @click="selectPreviewProduct(product)"
            v-for="(product, i) in products"
            :key="i"
          >
            <v-list-item-title>{{ product.name }}</v-list-item-title>
          </v-list-item>
          <v-list-item v-if="products.length >= 5" @click="searchProductModal = true">
            <v-list-item-content>
              <v-list-item-subtitle>{{$t('search_another_product')}}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-row>

    <div v-if="showResultSelector || showLanguageSelector || showCountrySelector" class="mt-5 mb-3">
      <v-row v-if="showResultSelector" justify="center" align="center" no-gutters class="mb-3">
        <v-col :class="showCountrySelector ? 'dropdown-wide' : 'dropdown'">
          <v-select hide-details v-model="previewResult" :items="results" item-text="name" item-value="key" solo dense></v-select>
        </v-col>
      </v-row>

      <v-row v-if="showLanguageSelector || showCountrySelector" justify="center" align="center" no-gutters :class="{ 'flex-column': !(showLanguageSelector && showCountrySelector) }">
        <v-col v-if="showLanguageSelector" :class="showCountrySelector ? 'dropdown-paired' : 'dropdown'">
          <v-select
            hide-details
            v-model="previewLanguage"
            :items="enabledLanguages"
            item-text="name"
            item-value="key"
            solo
            dense
            :label="$t('language')"
          ></v-select>
        </v-col>
        <v-col v-if="showCountrySelector" :class="showLanguageSelector ? 'dropdown-paired' : 'dropdown'">
          <v-select
            hide-details
            v-model="previewCountry"
            :items="countries"
            item-text="description"
            item-value="key"
            solo
            dense
            :label="$t('preview_country')"
          ></v-select>
        </v-col>
      </v-row>
    </div>

    <p v-if="isPreviewEnabled && hasElabelWidget" class="elabel-lang-hint">{{$t('preview_elabel_untranslated_hint')}}</p>

    <div class="phone-ctn" :class="{ 'mt-15': !isPreviewEnabled, 'fullscreen': fullscreen }">
      <img src="@/assets/iphone-frame.png">

      <div v-show="isPreviewEnabled || isCustomHtmlTab" class="phone-header font-weight-bold">
        {{pageTitle}}
      </div>

      <div class="phone-content">
        <!-- Custom HTML preview -->
        <iframe v-if="isCustomHtmlTab && customHtmlContent" ref="customHtmlIframe" :srcdoc="customHtmlContent" sandbox="allow-scripts" class="custom-html-preview-frame"></iframe>
        <div v-else-if="isCustomHtmlTab" class="preview-disabled">
          <span class="font-weight-light">{{$t('custom_html_preview_empty')}}</span>
        </div>
        <!-- Standard preview -->
        <iframe v-else-if="isPreviewEnabled" :src="iframeUrl"></iframe>
        <div v-else class="preview-disabled">
          <div v-if="needToUpdateRedirection">
            <div v-if="needToUpdateRedirection === 'product'">
              <span class="font-weight-light">{{$t('preview_unavailable')}}<br><br> {{$t('preview_unavailable_redirect')}}</span><br>
            </div>
            <div v-if="needToUpdateRedirection === 'url' ">
              <span class="font-weight-light">{{$t('preview_unavailable')}} {{$t('preview_unavailable_check_url')}}</span><br>
              <a target="_blank" rel="noopener noreferrer" :href="redirectUrl" ><v-btn text color="primary">{{$t('preview_unavailable_go_to_url')}}</v-btn></a>
            </div>
          </div>
          <div v-else>
            <div v-if="redirectionMode === 'product'">
              <span class="font-weight-light">{{$t('preview_unavailable')}}<br><br> {{$t('preview_unavailable_redirect')}}</span>
            </div>
            <div v-if="redirectionMode === 'url' ">
              <span class="font-weight-light">{{$t('preview_unavailable')}} {{$t('preview_unavailable_check_url')}}</span><br>
              <a target="_blank" rel="noopener noreferrer" :href="redirectUrl" ><v-btn text color="primary">{{$t('preview_unavailable_go_to_url')}}</v-btn></a>
            </div>
          </div>
        </div>
      </div>

    </div>

    <v-btn @click="displayPreviewModal" v-if="isPreviewEnabled" class="font-weight-bold mt-1" left text color="primary" >
      <v-icon>$preview</v-icon>
      {{$t('preview_title')}}
    </v-btn>

    <v-dialog scrollable v-model="searchProductModal" width="500">
      <v-card>
        <v-card-title class="headline">{{$t('search_product_title')}}</v-card-title>
        <v-card-text class="pa-5">
          <v-autocomplete
            persistent-hint
            no-filter
            :hint="hasManyCampaigns ? $t('search_product_hint') : ''"
            :label="$t('search_product_placeholder')"
            :items="modalProducts"
            :search-input.sync="search"
            item-text="name"
            :no-data-text="$t('no_result_found')"
            v-model="modalPreviewProduct"
            return-object
            :loading="loadingProducts"></v-autocomplete>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="searchProductModal = false" text>{{$t('close')}}</v-btn>
          <v-btn color="primary" @click="selectProductInModal()" text>{{$t('select')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog scrollable v-model="previewModal" :width="isTokenRefreshForced ? 300 : 700">
      <v-card>
        <v-card-title class="headline">{{ previewModalTitle }}</v-card-title>
        <v-row justify="center" align="center" class="ma-4" v-if="isTokenRefreshForced">
          <v-progress-circular indeterminate color="primary"/>
        </v-row>
        <v-card-text v-if="!isTokenRefreshForced">
          <div class="qrcode-ctn">
            <div class="hint font-weight-bold">{{ $t('preview_code_testing_purposes')}}</div>
            <v-row v-if="isAvailable('editor:authentication')" class="ma-0 mb-2" justify="center" align="center">
              <v-col class="result-select shrink">
                <v-select hide-details v-model="previewResult" :items="results" item-text="name" item-value="key" solo dense></v-select>
              </v-col>
            </v-row>
            <v-col class="qr-content">
              <qrcode-vue :value="`${iframeUrl}&banner=true`" :size="qrCodeSize" level="H" class="qr-content"></qrcode-vue>
            </v-col>
          </div>
        </v-card-text>
        <v-card-actions v-if="!isTokenRefreshForced">
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="previewModal = false" text>{{$t('dismiss')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>

import ProductService from '@/services/products'
import { mapGetters, mapMutations } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import Languages from '@/utils/languages'
import Countries from '@/utils/countries'
import Api from '@/api.js'
import { interpolateHtml, applyScanResultStyling, PRODUCT_IMAGE_PLACEHOLDER } from '@/utils/interpolateHtml'
import { annotateHtmlForPreview, reconstructHtml } from '@/utils/htmlBlockExtractor'

export default {
  name: 'preview',
  props: ['mode', 'fullscreen'],
  components: {
    QrcodeVue
  },
  data () {
    return {
      modalProducts: [],
      previewProduct: null,
      modalPreviewProduct: {},
      loadingProducts: false,
      search: '',
      searchProductModal: false,
      previewModal: false,
      qrCodeSize: 400,
      baseUrl: `${Api.editor_url}?editor=true`,
      previewCountry: 'IT',
      countries: Countries,
      // result: 'active',
      lang: 'en',
      results: [
        { name: this.$t('active_code'), key: 'active' },
        { name: this.$t('genuine'), key: 'genuine' },
        { name: this.$t('unable_to_verify'), key: 'fake' }
        // { name: 'Active (Unsupported phone)', key: 'active-unsupported'}
      ]
    }
  },
  computed: {
    ...mapGetters(['initialized', 'editor', 'pageTitle', 'apiKey', 'editorKey', 'previewUrl', 'scantrustAuthToken', 'remoteConfig', 'redirectionMode', 'redirectUrl', 'isAvailable', 'needToUpdateRedirection', 'previewResult', 'campaignId', 'hasManyCampaigns', 'products', 'company', 'currentProduct', 'isSelfServe', 'isTokenRefreshForced', 'activeEditorTab', 'activeEditorTabId', 'defaultLanguage', 'hoveredBlockId', 'hoverSource', 'getBlocksMeta', 'getHtmlBlocks', 'dynamicVariablesAndScmFields', 'productStcData', 'hasElabelWidget']),

    showCountrySelector () {
      return this.isPreviewEnabled && this.hasElabelWidget
    },

    isCustomHtmlTab () {
      if (this.$route.name !== 'config-editor') return false
      return this.activeEditorTab && this.activeEditorTab.type === 'custom-html'
    },

    showResultSelector () {
      return this.isPreviewEnabled && this.isAvailable('editor:authentication')
    },

    showLanguageSelector () {
      if (this.enabledLanguages.length <= 1) return false
      return this.isCustomHtmlTab || this.showResultSelector
    },

    previewInterpolationData () {
      const product = this.previewProduct || {}
      const resultMap = { genuine: 'Genuine', active: 'Active', fake: 'Unable to verify' }
      const overrides = this.editor &&
        this.editor['product-infos'] &&
        this.editor['product-infos'].auth_message &&
        this.editor['product-infos'].auth_message[this.previewResult]
      const authMessageOverride = (overrides && overrides[this.previewLanguage]) ||
        (overrides && overrides[this.defaultLanguage]) ||
        ''
      const data = {
        product_name: product.name || 'N/A',
        product_description: product.description || 'N/A',
        product_sku: product.sku || 'N/A',
        product_url: product.url || 'N/A',
        product_image: product.image || PRODUCT_IMAGE_PLACEHOLDER,
        brand_name: (product.brand && product.brand.name) || 'N/A',
        scan_result: authMessageOverride || resultMap[this.previewResult] || 'Genuine',
        scan_result_status: this.previewResult || 'genuine',
        api_key: this.apiKey || 'N/A'
      }
      this.dynamicVariablesAndScmFields.forEach(field => {
        if (!(field.key in data)) {
          data[field.key] = 'N/A'
        }
      })
      this.productStcData.forEach(entry => {
        data['#' + entry.id] = entry.value || 'N/A'
      })
      return data
    },

    customHtmlContent () {
      if (!this.isCustomHtmlTab || !this.activeEditorTab.html) return ''
      const defaultHtml = this.activeEditorTab.html || ''
      const meta = this.activeEditorTabId ? this.getBlocksMeta(this.activeEditorTabId) : null
      const blocks = this.activeEditorTabId ? this.getHtmlBlocks(this.activeEditorTabId) : null

      let html = defaultHtml
      if (meta && Object.keys(meta).length && blocks && Object.keys(blocks).length) {
        html = reconstructHtml(defaultHtml, blocks, meta, this.previewLanguage, this.defaultLanguage)
      }

      const data = this.previewInterpolationData
      let out = interpolateHtml(html, data)
      if (meta && Object.keys(meta).length) {
        out = annotateHtmlForPreview(out, meta)
      }
      return applyScanResultStyling(out, data.scan_result_status)
    },

    previewLanguage: {
      get () {
        return this.$store.getters.previewLanguage
      },

      set (newVal) {
        if (typeof newVal === 'string') {
          this.setPreviewLanguage(newVal)
        }
      }
    },

    previewResult: {
      get () {
        return this.$store.getters.previewResult
      },

      set (result) {
        this.setPreviewResult(result)
      }
    },

    isPreviewEnabled () {
      if (this.company && this.company.intelligent_redirects_enabled) {
        return true
      }
      return this.redirectionMode === 'stc'
    },

    enabledLanguages: {
      get () {
        const list = []
        this.$store.getters.enabledLanguages.forEach((lang) => {
          list.push(Languages.list.filter((l) => l.key === lang)[0])
        })
        return list
      }
    },

    iframeUrl () {
      if (this.mode === 'remote') {
        return `${this.baseUrl}&api_key=${this.apiKey}&result=${this.previewResult}&lang=${this.previewLanguage}&key=${this.editorKey}&config=${this.remoteConfig.id}&token=${this.scantrustAuthToken}&product=${this.currentProduct && this.currentProduct.id ? this.currentProduct.id : this.previewProduct ? this.previewProduct.id : ''}${this.hasElabelWidget ? `&country=${this.previewCountry}` : ''}`
      } else {
        return `${this.baseUrl}&api_key=${this.apiKey}&result=${this.previewResult}&lang=${this.previewLanguage}&key=${this.editorKey}${this.hasElabelWidget ? `&country=${this.previewCountry}` : ''}`
      }
    },
    previewModalTitle () {
      if (this.isTokenRefreshForced) return this.$t('loading')
      return this.$t('scan_phone')
    }
  },
  watch: {
    // defaultLanguage (newVal) {
    //   console.log('new default lang', newVal)
    //   if (newVal) {
    //     this.setPreviewLanguage(newVal)
    //   }
    // },

    async search (val) {
      this.loadingProducts = true
      const res = await ProductService.loadProducts(this.campaignId, val)
      this.modalProducts = res
      this.loadingProducts = false
    },

    hoveredBlockId (blockId) {
      const iframe = this.$refs.customHtmlIframe
      if (!iframe || !iframe.contentWindow) return
      if (blockId) {
        iframe.contentWindow.postMessage({
          type: 'highlight-block',
          blockId,
          scroll: this.hoverSource !== 'preview'
        }, '*')
      } else {
        iframe.contentWindow.postMessage({ type: 'clear-highlight' }, '*')
      }
    }
  },
  mounted () {
    this._onIframeMessage = (event) => {
      const iframe = this.$refs.customHtmlIframe
      if (!iframe || event.source !== iframe.contentWindow) return
      const data = event.data
      if (!data || !data.type) return
      if (data.type === 'preview-hover') {
        this.$store.commit('SET_HOVERED_BLOCK_ID', { blockId: data.blockId || null, source: 'preview' })
      } else if (data.type === 'preview-click' && data.blockId) {
        this.$store.commit('SET_PREVIEW_CLICK_EVENT', data.blockId)
      }
    }
    window.addEventListener('message', this._onIframeMessage)
  },
  beforeDestroy () {
    if (this._onIframeMessage) {
      window.removeEventListener('message', this._onIframeMessage)
    }
  },
  methods: {
    ...mapMutations({
      changePreviewMode: 'CHANGE_PREVIEW_MODE',
      setPreviewLanguage: 'SET_PREVIEW_LANGUAGE',
      setPreviewResult: 'SET_PREVIEW_RESULT',
      setProductStcData: 'SET_PRODUCT_STC_DATA'
    }),

    async selectProductInModal () {
      this.previewProduct = this.modalPreviewProduct
      const stcData = await ProductService.loadProductStcData(this.previewProduct.id)
      this.setProductStcData(stcData)
      this.searchProductModal = false
    },

    async selectPreviewProduct (product) {
      this.previewProduct = product
      const stcData = await ProductService.loadProductStcData(product.id)
      this.setProductStcData(stcData)
    },

    updateQrCodeSize () {
      this.qrCodeSize = window.innerHeight <= 600 ? 350 : 400
    },

    closePreview () {
      this.changePreviewMode(false)
    },

    displayPreviewModal () {
      this.$store.dispatch('forceTokenRefresh', true)
      this.previewModal = true
      window.parent.postMessage({ type: 'forceTokenRefresh' }, '*')
    }

  },
  async created () {
    this.setPreviewLanguage(this.editor.default_language)

    this.previewProduct = this.products[0]

    this.updateQrCodeSize()
  }
}

</script>

<style lang="sass" scoped>

@import "@/variables.sass"

.product-name
  color: #0789b2

.qrcode-ctn
  margin-top: 12px
  text-align: center

.preview
  margin-top: 10px
  z-index: 9999
  text-align: center
  .mono
    font-size: 20px
    color: rgba(0,0,0,0.5)
    text-align: center

  .close-preview
    position: absolute
    top: 10px
    right: 10px

.dropdown
  flex: 0 0 auto
  width: 235px
  max-width: 100%

.dropdown-wide
  flex: 0 0 auto
  width: 288px
  max-width: 100%

.dropdown-paired
  flex: 0 0 auto
  width: 138px
  margin: 0 6px

.result-select
  min-width: 202px

.elabel-lang-hint
  max-width: 260px
  margin: 0 auto 10px
  font-size: 11px
  line-height: 1.35
  color: rgba(0, 0, 0, 0.55)

.phone-ctn
  margin-left: auto
  margin-right: auto
  width: 300px
  height: 530px
  &.fullscreen
    width: 320px
    .phone-content
      left: 18px !important

  border-radius: 30px
  z-index: 0
  position: relative
  margin-top: 7px
  @include xl
    width: 320px
    height: auto
    margin-top: 15px
    border-radius: 48px
  img
    position: relative
    width: 100%
    height: 100%
    z-index: 10

  .phone-header
    position: absolute
    z-index: 5
    top: 3px
    right: 16px
    left: 11px
    text-align: center
    padding-top: 27px
    border-radius: 30px 30px 0 0
    @include xl
      padding-top: 41px

    background: #f0eff5
    border-top: 10px solid #f0eff5

  .phone-content
    position: absolute
    bottom: 0
    z-index: 15
    top: 67px
    left: 18px
    right: 0px
    @include xl
      top: 77px
      right: 9px
      left: 7px

    .preview-disabled
      padding: 100px 40px 0px 20px
      text-align: center

    iframe
      border-radius: 0 0 20px 20px
      border: 0
      body
        margin: 0
      ::-webkit-scrollbar
        display: none

      height: 128%
      width: 125%
      -ms-zoom: 0.75
      -moz-transform: scale(0.75)
      -moz-transform-origin: 0 0
      -o-transform: scale(0.75)
      -o-transform-origin: 0 0
      -webkit-transform: scale(0.75)
      -webkit-transform-origin: 0 0

      @include xl
        border-radius: 0 0 20px 24px
        height: calc(100% - 26px)
        width: calc(100% - 23px)
        -ms-zoom: 1
        -moz-transform: scale(1)
        -moz-transform-origin: 0 0
        -o-transform: scale(1)
        -o-transform-origin: 0 0
        -webkit-transform: scale(1)
        -webkit-transform-origin: 0 0

.dialog-content
  text-align: center

  .results, .qr-content
    padding: 10px 20px

  .results
    max-width: 280px

  .hint
    color: #ee4444
    font-size: 14px

  @media (max-width: 809px)
    .results
      max-width: unset
    .result-select, .dropdown
      padding: 4px
    .dialog-content-divider
      display: none
    .hint
      text-align: center
</style>
